import React from "react";
import "./styleCard.scss";
import { Card } from "react-bootstrap";

const CardComponent = ({ nameofclass, children }) => (
  <Card className={`${nameofclass}`}>{children}</Card>
);

export default CardComponent;
